import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import * as _ from "lodash";
import { ToastrService } from "ngx-toastr";
import { CostRegistrationRelations } from "../../../models/cost_registration_relations";
import { ServiceLocationRegistrationRelations } from "../../../models/service_location_registration_relations";
import { CostRegistrationsControllerService } from "../../../services/crossed-tables/cost-registrations-controller.service";
import { ServiceLocationRegistrationsControllerService } from "../../../services/crossed-tables/service-location-registration-controller.service";
import { ServiceLocationControllerService } from "../../../services/location-controller/service-location-controller.service";
import { BaseError } from "../base-error";

@Component({
  selector: "app-cost-registrations",
  templateUrl: "./service-location-registrations.component.html",
  providers: [ServiceLocationRegistrationsControllerService],
})
export class ServiceLocationRegistrationsComponent extends BaseError implements OnInit {
  public serviceLocationRegistrationRelations: ServiceLocationRegistrationRelations[][] = [];
  public serviceId: string;
  public selectedServiceLocationRegistrationRelations: ServiceLocationRegistrationRelations;
  public rows = [];
  public columns = [];
  public headingsSwitched: boolean = false;
  public tableSwitched: boolean = false;

  constructor(private serviceLocationRegistrationsControllerService: ServiceLocationRegistrationsControllerService,
              private route: ActivatedRoute,
              toastr: ToastrService) {
    super(toastr);
  }

  public ngOnInit() {
    this.route.params.subscribe((params) => {
      this.serviceId = params.serviceId;
    });
    this.getServiceLocationRegistrationRelations();
  }

  public getServiceLocationRegistrationRelations() {
    this.serviceLocationRegistrationsControllerService.getServicelocationsRegistrationsRelationsList(this.serviceId).subscribe(
      (data) => {
        this.serviceLocationRegistrationRelations = data;
        if (this.tableSwitched) {
          this.tableSwitched = false;
          this.switchHeadings();
        }
      },
      (error) => this.showErrorMessageWithTitle("Error HTTP Post Service", error),
    );
  }

  public switchHeadings() {
    this.tableSwitched = !this.tableSwitched;
    const switchedEntries = [];
    if (this.serviceLocationRegistrationRelations[0]) {
      for (let j = 0; j < this.serviceLocationRegistrationRelations[0].length; j++) {
        const newRow = [];
        for (let i = 0; i < this.serviceLocationRegistrationRelations.length; i++) {
          newRow.push(this.serviceLocationRegistrationRelations[i][j]);
        }
        switchedEntries.push(newRow);
      }
    }
    this.serviceLocationRegistrationRelations = switchedEntries;
  }

  public updateCostRegistration(serviceLocationRegistrationRelations: ServiceLocationRegistrationRelations) {
    this.serviceLocationRegistrationsControllerService.saveServiceLocationRegistrations(this.serviceId, serviceLocationRegistrationRelations).subscribe(
      (data) => {
        this.getServiceLocationRegistrationRelations();
      },
      (error) => this.showErrorMessageWithTitle("Error HTTP Post Service", error),
    );
  }

  public editServiceLocationRegistrationEvent(serviceLocationRegistrationRelations: ServiceLocationRegistrationRelations) {
    if (serviceLocationRegistrationRelations) {
      this.selectedServiceLocationRegistrationRelations = serviceLocationRegistrationRelations;
      if (serviceLocationRegistrationRelations.registrationHasLocation) {
        this.selectedServiceLocationRegistrationRelations.registrationHasLocation = false;
        this.updateCostRegistration(this.selectedServiceLocationRegistrationRelations);
      } else {
        serviceLocationRegistrationRelations.registrationHasLocation = true;
        this.updateCostRegistration(serviceLocationRegistrationRelations);
      }
    }

  }

}
